import { useState, useEffect } from "react";
import React from "react";
import {
  machineProfile,
  part,
  vendor,
  customer,
  partCategory,
  purchaseOrder,
} from "../../api";
import { toast } from "react-toastify";
import {
  dateFormat,
  getEmptyField,
  getFileUrl,
  printLocation,
  renderImage,
} from "../../utils/helper";
import { QRCode } from "react-qrcode-logo";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useDashboardContext } from "../../contexts/NewDashboardContext";
import LoadingIndicator from "../../components/LoadingIndicator";
import NormalInput from "../../components/form/HorizontalNormalInput";
import NormalSelect from "../../components/form/HorizontalNormalSelect";
import NormalTextArea from "../../components/form/HorizontalNormalTextarea";
import { DatepickerOpt } from "../../components/form/DatepickerOpt";
import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { Card, CardBody, CardHeader } from "../../components/card/card";
import { MachineElement } from "../../components/MachineElement";
import ImageViewer from "../../components/ImageViewer";
import ConfirmationDlg from "../../components/ConfirmationDlg";
import { format } from "date-fns";
import { PurchaseOrderItem } from "../../components/PurchaseOrderItem";

function setupLocationValues(locationSeq, location) {
  locationSeq.push(location.id);
  if (location.parent_location) {
    setupLocationValues(locationSeq, location.parent_location);
  }
}
function AddPurchaseOrder() {
  const { id } = useParams();
  const { config } = useAuth();
  const editMode = !!id;
  const { locations } = useDashboardContext();
  const [sublocations, setSublocations] = useState([]);
  const [selectedFile, setSelectedFile] = useState("");
  const [vendorList, setVendor] = useState([]);
  const [customerList, setCustomer] = useState([]);
  const [schedules, setSchedules] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [inventories, setInventories] = useState([]);
  const [filesToUpload, setFilesToUpload] = useState([]);
  const [preview, setPreview] = useState();
  const [locationValue, setLocationValue] = useState([]);
  const { getLocationName } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const [billingAddressType, setBillingAddressType] = useState("custom");
  const [shippingAddressType, setShippingAddressType] = useState("custom");

  const [dataToSend, setDataToSend] = useState({
    name: "",
    number: "",
    vendor_id: "",
    description: "",
    billing_address: {},
    shipping_address: {},
    due_date: format(new Date(), "yyyy-MM-dd"),
    purchase_date: format(new Date(), "yyyy-MM-dd"),
    tax: 0,
    tax_type: "currency",
    shipping_cost: 0,
    other_cost: 0,
    items: [],
  });

  const navigate = useNavigate();

  const [emptyField, setEmptyField] = useState([]);

  function backToList() {
    navigate(-1);
  }

  async function getMasterData() {
    try {
      setIsLoading(true);

      const getVendor = vendor.list({});

      const [res] = await Promise.all([getVendor]);

      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data) {
          data.map((d) => {
            d["name"] = d.vendor_name;
            d["value"] = d.id;
          });
          setVendor(data);
        }
      }

      if (editMode) {
        await getRecord();
      }
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getMasterData();
  }, []);

  async function getRecord() {
    const result = await purchaseOrder.getOne(id);

    if (result.ok) {
      const body = await result.json();
      let data = body.data;

      const defaultValue = {
        name: data.name,
        number: data.number,
        vendor_id: data.vendor_id || "",
        description: data.description,
        billing_address: data.billing_address,
        shipping_address: data.shipping_address,
        due_date: format(new Date(data.due_date), "yyyy-MM-dd"),
        purchase_date: format(new Date(data.purchase_date), "yyyy-MM-dd"),
        tax: data.tax,
        tax_type: data.tax_type,
        shipping_cost: data.shipping_cost,
        other_cost: data.other_cost,
        items: data.items,
        file: data.file,
      };

      setDataToSend(defaultValue);
    }
  }

  const handleOnchange = (e) => {
    let key = e.target.name;

    if (key.includes(".")) {
      const [key1, key2] = key.split(".");
      setDataToSend((prevData) => ({
        ...prevData,
        [key1]: {
          ...prevData[key1],
          [key2]: e.target.value,
        },
      }));
    } else {
      setDataToSend((prevData) => ({
        ...prevData,
        [key]: e.target.value,
      }));
    }
  };

  // const handleOnChangeInventory = (e) => {
  //   let key = e.target.name;

  //   setInventory((prevData) => ({
  //     ...prevData,
  //     [key]: e.target.value,
  //   }));
  // };

  const handleSubmit = async () => {
    try {
      setIsLoading(true);

      let payload = { ...dataToSend };

      if (payload.items.length == 0) {
        toast.error("Please add at least 1 item for the purchase order");
        return;
      }
      payload.billing_address = JSON.stringify(payload.billing_address);
      payload.shipping_address = JSON.stringify(payload.shipping_address);
      payload.items = JSON.stringify(payload.items);

      const mandatory = ["name", "description"];
      const ef = getEmptyField(payload, mandatory);
      setEmptyField(ef);
      if (ef.length > 0) {
        toast.error("Mandatory field must be filled");
        return;
      }

      //console.log({ payload });

      let res;
      if (!editMode) {
        res = await purchaseOrder.create(payload, selectedFile);
      } else {
        res = await purchaseOrder.update(id, payload, selectedFile);
      }

      setIsLoading(false);
      if (res.ok) {
        toast.success("Successfully Saved");
        if (!editMode) {
          backToList();
        } else {
          getRecord();
        }
      } else {
        toast.error("Something went wrong, please try again");
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeBillingAddressType = (type) => {
    setBillingAddressType(type);

    if (type == "company") {
      setDataToSend((prevData) => ({
        ...prevData,
        billing_address: {
          company_name: config.company_name,
          address: config.company_address,
          phone_number: config.contact_number,
        },
      }));
    } else {
      setDataToSend((prevData) => ({
        ...prevData,
        billing_address: {
          company_name: "",
          address: "",
          phone_number: "",
        },
      }));
    }
  };

  const handleChangeShippingAddressType = (type) => {
    setShippingAddressType(type);

    if (type == "same") {
      setDataToSend((prevData) => ({
        ...prevData,
        shipping_address: {
          company_name: prevData.billing_address.company_name,
          address: prevData.billing_address.address,
          phone_number: prevData.billing_address.phone_number,
        },
      }));
    } else {
      setDataToSend((prevData) => ({
        ...prevData,
        shipping_address: {
          company_name: "",
          address: "",
          phone_number: "",
        },
      }));
    }
  };

  const getTotal = () => {
    const subtotal = dataToSend.items.reduce((prev, cur) => {
      return prev + cur.cost * cur.quantity;
    }, 0);
    if (dataToSend.tax_type == "currency") {
      return (
        subtotal +
        Number(dataToSend.tax) +
        Number(dataToSend.shipping_cost) +
        Number(dataToSend.other_cost)
      );
    }

    return (
      subtotal +
      Number((subtotal * dataToSend.tax) / 100) +
      Number(dataToSend.shipping_cost) +
      Number(dataToSend.other_cost)
    );
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  return (
    <Card>
      <LoadingIndicator open={isLoading} />
      <CardHeader>{editMode && "Edit "}Purchase Order Information</CardHeader>

      <CardBody>
        <div className="row">
          <div className="col-9">
            <div>
              <NormalInput
                required={true}
                value={dataToSend["name"]}
                label="Title"
                onchange={handleOnchange}
                name="name"
                emptyField={emptyField}
              />
              {!editMode && (
                <NormalInput
                  value={dataToSend["number"]}
                  label="PO Number"
                  onchange={handleOnchange}
                  name="number"
                  type="number"
                  emptyField={emptyField}
                  helperText={
                    "The PO number will be auto-generated unless a custom PO number is entered"
                  }
                />
              )}

              <NormalInput
                label={"Due Date"}
                type="date"
                onchange={handleOnchange}
                value={dataToSend["due_date"]}
                name={"due_date"}
                emptyField={emptyField}
                className="form-control"
                required
              />

              <NormalTextArea
                required={true}
                value={dataToSend["description"]}
                label="Description"
                onchange={handleOnchange}
                name="description"
                emptyField={emptyField}
              />
            </div>
          </div>
        </div>

        <div className="mb-4">
          <PurchaseOrderItem
            onChange={(v) =>
              handleOnchange({
                target: {
                  name: "items",
                  value: v,
                },
              })
            }
            value={dataToSend["items"]}
          />
        </div>

        {dataToSend.items.length > 0 && (
          <Card className={"mb-4"}>
            <CardBody>
              <div>
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "separate",
                    borderSpacing: ".5em 1em",
                  }}
                >
                  <tbody>
                    <tr>
                      <td>Subtotal</td>
                      <td>:</td>
                      <td>
                        {config?.currency_symbol}{" "}
                        {dataToSend.items.reduce((prev, cur) => {
                          return prev + cur.cost * cur.quantity;
                        }, 0)}
                      </td>
                    </tr>
                    <tr>
                      <td>Taxes</td>
                      <td>
                        <select
                          onChange={handleOnchange}
                          name="tax_type"
                          value={dataToSend.tax_type}
                          className="form-control"
                        >
                          <option value="currency">
                            {config?.currency_symbol}
                          </option>
                          <option value="percentage">%</option>
                        </select>
                      </td>
                      <td>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <div class="input-group-text">
                              {dataToSend.tax_type == "currency"
                                ? config.currency_symbol
                                : "%"}
                            </div>
                          </div>
                          <input
                            onChange={handleOnchange}
                            name="tax"
                            className="form-control"
                            value={dataToSend.tax}
                            type="number"
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>Shipping</td>
                      <td></td>
                      <td>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <div class="input-group-text">
                              {config?.currency_symbol}
                            </div>
                          </div>
                          <input
                            onChange={handleOnchange}
                            className="form-control"
                            name="shipping_cost"
                            type="number"
                            value={dataToSend.shipping_cost}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>Other Costs</td>
                      <td>:</td>
                      <td>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <div class="input-group-text">
                              {config?.currency_symbol}
                            </div>
                          </div>
                          <input
                            className="form-control"
                            type="number"
                            name="other_cost"
                            onChange={handleOnchange}
                            value={dataToSend.other_cost}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <b>Total</b>
                      </td>
                      <td>:</td>
                      <td>
                        {config?.currency_symbol} {getTotal()}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>
        )}

        <Card className="mb-4">
          <CardHeader>Upload Photo / File</CardHeader>
          <CardBody>
            <div class="form-group">
              <input
                type="file"
                onChange={handleFileChange}
                class="form-control"
              />

              {dataToSend.file && (
                <p className="mt-2">
                  Uploaded File :{" "}
                  <a href={getFileUrl(dataToSend.file)} target="_blank">
                    Here
                  </a>{" "}
                </p>
              )}
            </div>
          </CardBody>
        </Card>

        {["billing_address", "shipping_address"].map((item) => (
          <Card key={item} className="mb-4">
            <CardHeader>
              <div style={{ textTransform: "capitalize" }}>
                {item.replace("_", " ")}
              </div>
            </CardHeader>
            <CardBody>
              {item == "billing_address" && (
                <>
                  <div className="form-check mb-2">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="exampleRadios"
                      id="exampleRadios1"
                      value="company"
                      onClick={() => handleChangeBillingAddressType("company")}
                      checked={billingAddressType == "company"}
                    />
                    <label className="form-check-label" for="exampleRadios1">
                      Use address from Company Profile
                    </label>
                  </div>
                  <div className="form-check mb-2">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="exampleRadios"
                      id="exampleRadios2"
                      value="custom"
                      onClick={() => handleChangeBillingAddressType("custom")}
                      checked={billingAddressType == "custom"}
                    />
                    <label className="form-check-label" for="exampleRadios2">
                      Use a different address
                    </label>
                  </div>
                </>
              )}

              {item == "shipping_address" && (
                <NormalInput
                  label={"Ship To Name"}
                  onchange={handleOnchange}
                  value={dataToSend[item]["ship_to_name"]}
                  name={`${item}.ship_to_name`}
                  className="form-control"
                />
              )}

              {item == "shipping_address" && (
                <>
                  <div className="form-check mb-2">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="shipping"
                      id="shipping1"
                      value="company"
                      onClick={() => handleChangeShippingAddressType("same")}
                      checked={shippingAddressType == "same"}
                    />
                    <label className="form-check-label" for="shpping1">
                      Same as billing address
                    </label>
                  </div>
                  <div className="form-check mb-2">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="shipping"
                      id="shipping2"
                      value="custom"
                      onClick={() => handleChangeShippingAddressType("custom")}
                      checked={shippingAddressType == "custom"}
                    />
                    <label className="form-check-label" for="shipping2">
                      Use a different address
                    </label>
                  </div>
                </>
              )}

              <NormalInput
                label={"Company Name"}
                onchange={handleOnchange}
                value={dataToSend[item]["company_name"]}
                name={`${item}.company_name`}
                className="form-control"
              />

              <NormalInput
                label={"Address"}
                onchange={handleOnchange}
                value={dataToSend[item]["address"]}
                name={`${item}.address`}
                className="form-control"
              />

              <NormalInput
                label={"Phone Number"}
                onchange={handleOnchange}
                value={dataToSend[item]["phone_number"]}
                name={`${item}.phone_number`}
                className="form-control"
              />
            </CardBody>
          </Card>
        ))}

        <Card>
          <LoadingIndicator open={isLoading} />
          <CardHeader>More Information</CardHeader>
          <CardBody>
            <NormalSelect
              value={dataToSend["vendor_id"]}
              label="Vendor"
              onchange={handleOnchange}
              list={vendorList}
              valueKey="id"
              name="vendor_id"
            />

            <NormalInput
              label={"Purchase Date"}
              type="date"
              onchange={handleOnchange}
              value={dataToSend["purchase_date"]}
              name={"purchase_date"}
              emptyField={emptyField}
              className="form-control"
            />
          </CardBody>
        </Card>

        <div className="mt-4 flex">
          <button
            className="btn btn-outline-theme btn-lg me-2"
            onClick={handleSubmit}
          >
            {editMode ? "SAVE" : "ADD"}
          </button>
          <button
            className="btn btn-outline-danger btn-lg"
            onClick={backToList}
          >
            CANCEL
          </button>
        </div>
      </CardBody>
    </Card>
  );
}

export default AddPurchaseOrder;
